module.exports = __webpack_public_path__ + "img/catalog-category-opravy.d573851.png?v=1764327952164";